"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHelpCircular(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8.0092 0a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm.5129 11.2519a.7775.7775 0 1 1 -1.555.00056v-.30436a.7775.7775 0 0 1 1.555 0zm-.0829-1.9319a.10993.10993 0 0 1 -.09945.1195l-.01055.0005h-1a.1.1 0 0 1 -.11-.08888.093.093 0 0 1 0-.0211c0-1.8908 1.57-2.1183 1.57-3.1a1.33877 1.33877 0 0 0 -.1801-.7.66983.66983 0 0 0 -.6399-.35.69012.69012 0 0 0 -.63.45 2.13308 2.13308 0 0 0 -.11.83h-1.22c0-3.5205 4-3.1346 4-.31 0 1.50878-1.57 1.54018-1.57 3.16998z' })));
}
exports.default = SvgHelpCircular;
